import gql from 'graphql-tag';
import HelperGraphql from 'utils/helper-graphql'
import FieldsChart from 'graphql/fields/FieldsChart'
import VariablesChart from 'graphql/variables/VariablesChart'

const fields = {
	...VariablesChart,
};

export default gql(`
	query chart_employee_bookings_week( ${ HelperGraphql.createFields( fields ) } ) {
		chart_employee_bookings_week( ${ HelperGraphql.createVariables( fields ) } ) {
	        ${FieldsChart}
	    }
	}
`);

